import React from 'react';
import { ArrowDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import HeroImage from '../assets/herosec_image.a25f8d6d.png';
import CounselingImage from '../assets/cbt-img3.a94b45f0.jpg';

export default function CounselingPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Hero Section with Background Image */}
      <section className="relative min-h-[600px] flex items-end bg-cover bg-center" 
               style={{
                 backgroundImage: `url(${HeroImage})`
               }}>
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-0">
          <div className="flex flex-col lg:flex-row items-end gap-8 lg:gap-12">
            {/* Left Content Card - Positioned at bottom */}
            <div className="lg:w-1/2 w-full relative mb-0">
              <div className="bg-slate-700/50 backdrop-blur-sm p-8 md:p-10 lg:p-12 rounded-t-lg shadow-lg">
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
                  Empowering Lives Through Expert Counseling Services
                </h1>
                <p className="text-sm md:text-base text-white/90 leading-relaxed mb-8">
                  Discover personalized counseling services designed to support your mental well-being, 
                  enhance relationships, and foster personal growth. Our expert counselors provide 
                  compassionate care tailored to your needs.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center mb-16">
                  <button onClick={() => navigate('/book-now')} className="bg-white hover:bg-gray-100 text-green-600 px-6 py-3 rounded font-medium transition-colors">
                    BOOK NOW
                  </button>
                </div>
              </div>
              {/* Arrow button positioned at bottom right corner of card */}
              <button onClick={() => navigate('/book-now')} className="absolute bottom-0 right-0 bg-green-600 hover:bg-green-700 text-white p-3 rounded-tl-lg transition-colors shadow-lg">
                <ArrowDown className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-12 md:py-16 lg:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* Left Content */}
            <div className="lg:w-1/2 space-y-8">
              <div>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-black mb-6">
                  Tailored Counselling Services For Your Well-Being
                </h2>
                
                <div className="space-y-4 text-sm md:text-base text-gray-700 leading-relaxed">
                  <p>
                    Your mental health deserves attention-here we guide you to address life transitions, 
                    work on your self-image, and help manage stress and anxiety. We offer a comprehensive 
                    solution to reaching your emotional wellbeing goals. Our unique approach, involving a 
                    safe space to navigate your unique needs, providing a safe space to navigate your 
                    goals and help with stress, anxiety, relationships, or life transitions, our trained 
                    counsellors can support your journey towards health.
                  </p>
                  
                  <p>
                    We offer a variety of flexible options like self-help books, online resources, and 
                    the most popular counseling sessions. These therapy sessions provide one-on-one 
                    counseling sessions based on different approaches like CBT, EMDR, and Gestalt, 
                    understanding the different backgrounds and approaches like DBT, EMDR, and Gestalt. 
                    Our goal is to give you the tools you need to take positive steps on your journey.
                  </p>
                  
                  <p>
                    Experience the transformative power of individual soul coaching and best the 
                    first step towards a healthier relationship with yourself and others.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Right Content - Image */}
            <div className="lg:w-1/2">
              <div className="rounded-lg overflow-hidden shadow-lg">
                <img 
                  src={CounselingImage} 
                  alt="Counseling session" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-12 md:py-16 lg:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-black mb-8 md:mb-12 text-center">
            Benefits of Hiring Our Expert Therapists
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {/* Benefit 1 */}
            <div className="space-y-4">
              <h3 className="text-lg md:text-xl font-bold text-black">
                Personalized Treatment Plans
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                Expert therapists craft tailored solutions to address your unique challenges, ensuring effective and results-driven care. This 
                approach ensures that you receive only the most relevant care.
              </p>
            </div>
            
            {/* Benefit 2 */}
            <div className="space-y-4">
              <h3 className="text-lg md:text-xl font-bold text-black">
                Access to Proven Techniques
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                Expert therapists are trained in evidence-based approaches like CBT, mindfulness, or EMDR, delivering solutions backed by research. 
                Their expertise ensures that progress will align with best practices.
              </p>
            </div>
            
            {/* Benefit 3 */}
            <div className="space-y-4">
              <h3 className="text-lg md:text-xl font-bold text-black">
                Confidential and Safe Space
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                An expert therapist provides a judgment-free environment to explore your emotions. This sense of safety fosters open dialogue 
                and helps you maintain clarity and healing.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-12 md:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-black mb-8 md:mb-12">
            How It Works
          </h2>
          
          <div className="space-y-8 md:space-y-12">
            {/* Step 1 */}
            <div className="space-y-4">
              <h3 className="text-lg md:text-xl font-bold text-black">
                Initial Consultation
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                Begin with a confidential consultation where you can openly share your concerns, challenges, and therapy goals. This 
                initial step helps us understand your unique needs.
              </p>
            </div>
            
            {/* Step 2 */}
            <div className="space-y-4">
              <h3 className="text-lg md:text-xl font-bold text-black">
                Customized Therapy Plan
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                Our expert counselors develop a tailored plan just for you. Whether you prefer face-to-face sessions, online meetings, or group 
                sessions, we fit the plan you need to your preferences.
              </p>
            </div>
            
            {/* Step 3 */}
            <div className="space-y-4">
              <h3 className="text-lg md:text-xl font-bold text-black">
                Your Journey to Wellness
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                Start your sessions in your comfortable and secure space. We focus on equipping you with practical tools, coping techniques, and 
                emotional support to help you reach your wellness goals.
              </p>
            </div>
            
            {/* Step 4 */}
            <div className="space-y-4">
              <h3 className="text-lg md:text-xl font-bold text-black">
                Ongoing Support
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                Our services continue even after your initial sessions, with long-term consultations aimed at every step, empowering you to take control of your 
                mental well-being with expert guidance and tools. Regular progress assessments keep you on track.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}